import { CollapsableSectionHeader } from '@aon/aon-tws-common-ui/build/lib/components/SectionHeader';
import * as React from 'react';
import styled from 'styled-components';

export interface ISectionProps {
	id?: string;
	sectionHeader: any;
}

const StyledSection = styled.div``;
StyledSection.displayName = 'StyledSection';

export const SectionContent = styled.div`
	padding: 50px 30px;
	width: 100%;
	@media (min-width: 0) and (max-width: 768px) {
		padding-right: 0;
		padding-left: 0;
	}
`;
SectionContent.displayName = 'SectionContent';

export class CollapsableSection extends React.PureComponent<React.PropsWithChildren<ISectionProps>> {
	public render() {
		return (
			<StyledSection id={this.props.id}>
				<CollapsableSectionHeader headerContent={this.props.sectionHeader}>
					<SectionContent>{this.props.children}</SectionContent>
				</CollapsableSectionHeader>
			</StyledSection>
		);
	}
}
